import React from "react";
import "./Services.css";
import { motion } from "framer-motion";
import {NavLink} from "react-router-dom"
import {
  FaTshirt,
  FaSoap,
  FaBed,
  // FaIron,
  FaShoePrints,
  FaShoppingBag,
} from "react-icons/fa";

import { MdOutlineIron } from "react-icons/md";


const servicesData = [
  {
    icon: <FaTshirt />,
    title: "Dry Cleaning",
    desc: "Dry Cleaning & Laundry",
    url:"/expert-services"
  },
  {
    icon: <FaSoap />,
    title: "Wash & Fold",
    desc: "Everyday Laundry",
        url:"/washfold"

  },
  {
    icon: <FaBed />,
    title: "Bed & Bath",
    desc: "Laundry Home Linens",
        url:"/drycleaning"

  },
  {
    icon: <MdOutlineIron />,
    title: "Press Only",
    desc: "Pressing & Steaming",
        url:"/press-only"

  },
  {
    icon: <FaShoePrints />,
    title: "Shoe Care",
    desc: "Cleaning & Restoration",
        url:"/shoe-care"

  },
  {
    icon: <FaShoppingBag />,
    title: "Bag Care",
    desc: "Cleaning & Restoration",
        url:"/bagcare-section"

  },
];
const Services = () => {
  return (
    <section className="services">
      <div className="container">

        {/* LEFT */}
        <div className="left-service mt-5">
          <h1 className="how-title">Our Services</h1>
          <p className="subtitle mt-4">
            Complete Laundry and Fabric Care Solutions
          </p>

          <div className="image-box-services mt-4">
            <img
              src="https://cdn.create.vista.com/api/media/medium/184076242/stock-photo-cropped-shot-young-woman-putting-laundry-washing-machine?token="
              alt="laundry"
            />
          </div>
        </div>

        {/* RIGHT */}
        <div className="right-service">
    
  {servicesData.map((item, index) => (
    <motion.div
      key={index}
      className="card-services"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.2 }}
      whileHover={{ y: -6 }}
    >
      <div className="icon-services">{item.icon}</div>

      <div className="card-content">
        <h4>{item.title}</h4>
        <p>{item.desc}</p>

        
          <NavLink to={item.url}>
  <button className="learn-btn-services-oures">
    Learn More →
  </button>
</NavLink>
      </div>
    </motion.div>
  ))}

        </div>

      </div>
    </section>
  );
};

export default Services;